import React from 'react';

import {
  Column,
  ErrorTag,
  FormBody,
  OutlineButton,
  PrimaryButton,
} from 'components/layout/Auth/AuthForm/styles';
import { formatarRestante } from 'components/layout/Auth/useCountdown';

import {
  CONTENT_WIDTH,
  Countdown,
  NarrowActions,
  OnboardingIntro,
  OnboardingSubtitle,
  OnboardingTitle,
  SmallTokenInput,
} from '../styles';

export type TokenStatus = 'aguardando' | 'invalido';

type ValidarTokenProps = {
  codigo: string;
  status: TokenStatus;
  restante: number;
  expirado: boolean;
  loading: boolean;
  erro: string | null;
  onChangeCodigo: (codigo: string) => void;
  onSubmit: (codigo: string) => void;
  onReenviar: () => void;
  onBack: () => void;
};

const TAMANHO = 6;

const ValidarToken = ({
  codigo,
  status,
  restante,
  expirado,
  loading,
  erro,
  onChangeCodigo,
  onSubmit,
  onReenviar,
  onBack,
}: ValidarTokenProps): JSX.Element => {
  const invalido = status === 'invalido';
  const podeEnviar = !loading && !expirado && codigo.length === TAMANHO;

  if (expirado) {
    return (
      <Column gap={24} width={CONTENT_WIDTH}>
        <OnboardingIntro>
          <OnboardingTitle>Tempo excedido!</OnboardingTitle>
          <OnboardingSubtitle>
            Clique em &quot;reenviar código&quot; e tente novamente
          </OnboardingSubtitle>
        </OnboardingIntro>

        <NarrowActions>
          <OutlineButton
            type="button"
            variant="secondary"
            shape="pill"
            fullWidth
            onClick={onBack}
          >
            Voltar
          </OutlineButton>
          <PrimaryButton
            type="button"
            shape="pill"
            fullWidth
            disabled={loading}
            onClick={onReenviar}
          >
            {loading ? 'Enviando...' : 'Reenviar código'}
          </PrimaryButton>
        </NarrowActions>
      </Column>
    );
  }

  const handleSubmit = (event: React.FormEvent): void => {
    event.preventDefault();
    if (podeEnviar) onSubmit(codigo);
  };

  return (
    <Column gap={24} width={CONTENT_WIDTH}>
      <OnboardingIntro>
        <OnboardingTitle>Código enviado!</OnboardingTitle>
        <OnboardingSubtitle>
          Digite o código que você recebeu no e-mail (Token):
        </OnboardingSubtitle>
      </OnboardingIntro>

      <form onSubmit={handleSubmit} noValidate>
        <FormBody>
          <SmallTokenInput
            value={codigo}
            length={TAMANHO}
            error={invalido}
            disabled={loading}
            message={invalido ? 'Token inválido ou expirado' : undefined}
            onChange={onChangeCodigo}
            onComplete={onSubmit}
          />

          <Countdown>{formatarRestante(restante)}</Countdown>

          {!!erro && <ErrorTag role="alert">{erro}</ErrorTag>}

          <NarrowActions>
            <OutlineButton
              type="button"
              variant="secondary"
              shape="pill"
              fullWidth
              onClick={onBack}
            >
              Voltar
            </OutlineButton>
            <PrimaryButton
              type="submit"
              shape="pill"
              fullWidth
              disabled={!podeEnviar}
            >
              {loading ? 'Validando...' : 'Continuar'}
            </PrimaryButton>
          </NarrowActions>
        </FormBody>
      </form>
    </Column>
  );
};

export default ValidarToken;
